var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipsis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 4,
    viewBox: "0 0 15 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.88899 0C2.93224 0 3.77797 0.845727 3.77797 1.88899C3.77797 2.93224 2.93224 3.77797 1.88899 3.77797C0.845727 3.77797 0 2.93224 0 1.88899C0 0.845727 0.845727 0 1.88899 0ZM7.43038 0C8.47364 0 9.31937 0.845727 9.31937 1.88899C9.31937 2.93224 8.47364 3.77797 7.43038 3.77797C6.38713 3.77797 5.5414 2.93224 5.5414 1.88899C5.5414 0.845727 6.38713 0 7.43038 0ZM12.9709 0C14.0141 0 14.8599 0.845727 14.8599 1.88899C14.8599 2.93224 14.0141 3.77797 12.9709 3.77797C11.9276 3.77797 11.0819 2.93224 11.0819 1.88899C11.0819 0.845727 11.9276 0 12.9709 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsis);
export default __webpack_public_path__ + "static/media/ellipsis.34b838a9e5c9aeb6edb204efeae1b1ed.svg";
export { ForwardRef as ReactComponent };